import type { QueryDef } from '@/hooks/useDefinedQuery'
import { getBinders, getBinder, getSharedBinder } from '@/services/api/binders'

export const bindersQueries = {
  list: {
    queryKey: () => ['binders'] as const,
    queryFn: getBinders,
    auth: 'required',
  } satisfies QueryDef<Awaited<ReturnType<typeof getBinders>>>,
  detail: {
    queryKey: (id: number) => ['binder', id] as const,
    queryFn: (id: number) => getBinder(id),
    auth: 'required',
  } satisfies QueryDef<Awaited<ReturnType<typeof getBinder>>, [number]>,
  shared: {
    queryKey: (token: string) => ['sharedBinder', token] as const,
    queryFn: (token: string) => getSharedBinder(token),
    auth: 'public',
  } satisfies QueryDef<Awaited<ReturnType<typeof getSharedBinder>>, [string]>,
}
